"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAtRequest = exports.checkIfThereAreResults = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const prop_types_1 = __importDefault(require("prop-types"));
const next12_components_modal_1 = __importDefault(require("@gcloud-npm/next12.components.modal"));
const next12_components_icon_n_1 = __importDefault(require("@gcloud-npm/next12.components.icon-n"));
const next12_app_controller_reducers_sagas_modals_reducer_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer");
const next12_app_controller_reducers_sagas_header_reducer_r_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.header-reducer-r");
const support_search_1 = __importDefault(require("../../modals/support-search"));
const INPUT_ID = "inputsupportadnsearch";
let QUERY = "";
const checkIfThereAreResults = ({ pagesSuggestedList, querySuggestedInputs, checkPages = true, checkAt = true, }) => {
    let res = false;
    if (checkPages) {
        const thereArePages = pagesSuggestedList &&
            ((pagesSuggestedList.regular && pagesSuggestedList.regular.length > 0) ||
                (pagesSuggestedList.services &&
                    pagesSuggestedList.services.length > 0) ||
                (pagesSuggestedList.devices && pagesSuggestedList.devices.length > 0));
        res = thereArePages;
    }
    if (checkAt) {
        const checkATInputs = querySuggestedInputs && querySuggestedInputs.length > 0;
        res = res || checkATInputs;
    }
    console.log("checkIfThereAreResults: ", {
        res,
        pagesSuggestedList,
        querySuggestedInputs,
    });
    return res;
};
exports.checkIfThereAreResults = checkIfThereAreResults;
const handleAtRequest = ({ label, event, checkPages, checkAt, pagesSuggestedList = null, querySuggestedInputs = null, }) => {
    try {
        const inputValue = document.getElementById(INPUT_ID).value;
        let query = label || inputValue;
        if (event) {
            event.preventDefault();
        }
        const detectAutocompleteOption = document.getElementById("hidden-query").value;
        const shouldSend = !(0, exports.checkIfThereAreResults)({
            checkPages,
            checkAt,
            pagesSuggestedList,
            querySuggestedInputs,
        });
        if ((shouldSend || detectAutocompleteOption) &&
            inputValue &&
            inputValue.length > 0) {
            query = encodeURIComponent(query);
            const name = "searcher";
            const content = encodeURIComponent(`${QUERY}`);
            const variation = detectAutocompleteOption
                ? "asistente-virtual"
                : "asistente-virtual-no-results";
            const urlToRedirect = `https://atencionalcliente.movistar.es/?q=${query}&name=${name}&content=${content}&variation=${variation}`;
            window.location.href = urlToRedirect;
        }
    }
    catch (error) { }
};
exports.handleAtRequest = handleAtRequest;
class SearchInput extends react_1.Component {
    constructor(props) {
        super(props);
        this.setResultModalOpen = (flag) => {
            this.resultModalOpen = flag;
        };
        this.setUp = () => {
            const { getSearcherInfo, pagesList } = this.props;
            if (!pagesList) {
                getSearcherInfo();
            }
        };
        this.onCloseHandler = () => {
            this.setResultModalOpen(false);
            this.handleClear({
                withCloseModal: true,
                withQueryReset: false,
            });
            const { addModal } = this.props;
            addModal({
                id: "closeAll",
            });
        };
        this.openSearchModal = () => {
            this.setResultModalOpen(true);
            const { addModal } = this.props;
            addModal({
                id: "searcher",
                Element2Show: support_search_1.default,
                modalProps: {
                    contentPosition: "center--top",
                    opacityLayoutColor: "blur",
                    inSceneEffect: "fadeIn",
                    contentInsideContainer: true,
                    outSceneEffect: "fadeOut",
                    closeByClickingOutside: true,
                    onCloseHandler: this.onCloseHandler,
                    createAnchor: false,
                },
                elementProps: {
                    visibleInput: false,
                },
            });
        };
        this.handleSearch = (query) => {
            const { getRelatedPages, onSearch, needOpenModalResults, pagesSuggestedList, querySuggestedInputs, } = this.props;
            // buscamos por paginas
            getRelatedPages(query);
            // comunicamos a quien lo necesite
            if (onSearch) {
                onSearch(query);
            }
            // gestion de modal
            if (needOpenModalResults && !this.resultModalOpen) {
                const shouldOpenModal = (0, exports.checkIfThereAreResults)({
                    checkPages: true,
                    checkAt: true,
                    pagesSuggestedList,
                    querySuggestedInputs,
                });
                if (shouldOpenModal) {
                    this.openSearchModal();
                }
                const { autoFocus } = this.props;
                if (autoFocus) {
                    document.getElementById(INPUT_ID).focus();
                }
            }
        };
        this.onInputClick = () => {
            this.setUp();
            this.setState({
                focus: true,
            });
        };
        this.onBlurClick = () => {
            this.setState({
                focus: false,
            });
        };
        this.handleClear = ({ withCloseModal = false, withQueryReset = true }) => {
            const { resetSearcher, onSearch, addModal, backButton } = this.props;
            if (withQueryReset) {
                QUERY = "";
                this.setState({ query: "" });
            }
            if (onSearch) {
                onSearch("");
            }
            if (withCloseModal) {
                this.setResultModalOpen(false);
                // significa mobile al final
                if (backButton) {
                    addModal({ id: "" });
                }
                else {
                    next12_components_modal_1.default.hide();
                }
            }
            resetSearcher();
        };
        this.handleInputChange = (event) => {
            const query = event.target.value;
            if (query && query.length >= 2) {
                this.handleSearch(event.target.value);
            }
            else {
                this.handleClear({
                    withCloseModal: false,
                    withQueryReset: true,
                });
            }
            QUERY = event.target.value;
            this.setState({
                query: event.target.value,
            });
        };
        this.resultModalOpen = false;
        this.state = {
            query: "",
            focus: false,
        };
    }
    componentDidMount() {
        const { autoFocus } = this.props;
        if (autoFocus) {
            // hacemos timeout para que funcione en safari
            setTimeout(() => {
                try {
                    document.getElementById(INPUT_ID).focus();
                }
                catch (err) { }
                try {
                    document.getElementById(INPUT_ID).click();
                }
                catch (err) { }
            }, 500);
            this.setUp();
        }
    }
    render() {
        const { query, focus } = this.state;
        const { backButton, placeHolder, autoComplete, pagesSuggestedList, querySuggestedInputs, } = this.props;
        return (react_1.default.createElement("form", { className: "form-searcher", id: `form-${INPUT_ID}`, onSubmit: (event) => {
                (0, exports.handleAtRequest)({
                    event,
                    checkAt: true,
                    checkPages: true,
                    pagesSuggestedList,
                    querySuggestedInputs,
                });
            } },
            react_1.default.createElement("div", { className: `SearchInput${focus ? " focus" : ""}`, "data-cy": "Header search" },
                react_1.default.createElement("button", { name: "buscar", title: "buscar", "aria-label": "buscar", type: "submit" },
                    react_1.default.createElement(next12_components_icon_n_1.default, { id: "Buscar", kind: "M", size: 22, color: "grey5" })),
                react_1.default.createElement("input", { id: INPUT_ID, className: "field", type: "search", value: query, onClick: this.onInputClick, onBlur: this.onBlurClick, autoComplete: autoComplete, onChange: this.handleInputChange, placeholder: placeHolder, "data-cy": "Header input search" }),
                react_1.default.createElement("input", { id: "hidden-query", type: "hidden" }),
                backButton && (react_1.default.createElement("button", { className: "clearButton", type: "button", onClick: () => this.handleClear({
                        withCloseModal: false,
                        withQueryReset: true,
                    }) },
                    react_1.default.createElement(next12_components_icon_n_1.default, { id: "cerrar", kind: "M", size: 12, color: "grey6" }))))));
    }
}
const mapStateToProps = (state) => ({
    querySuggestedInputs: state.header.querySuggestedInputs,
    pagesSuggestedList: state.header.pagesSuggestedList,
    pagesList: state.header.pagesList,
});
const mapDispatchToProps = (dispatch) => ({
    getSearcherInfo: () => dispatch(next12_app_controller_reducers_sagas_header_reducer_r_1.actions.getSearcherInfo()),
    addModal: (data) => dispatch(next12_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
    getSuggestedInputs: (query) => dispatch(next12_app_controller_reducers_sagas_header_reducer_r_1.actions.getSuggestedInputs(query)),
    resetSearcher: () => dispatch(next12_app_controller_reducers_sagas_header_reducer_r_1.actions.resetSearcher()),
    getRelatedPages: (query) => dispatch(next12_app_controller_reducers_sagas_header_reducer_r_1.actions.getRelatedPages(query)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(SearchInput);
SearchInput.propTypes = {
    backButton: prop_types_1.default.bool,
    placeHolder: prop_types_1.default.string,
    autoComplete: prop_types_1.default.string,
    needOpenModalResults: prop_types_1.default.bool,
    autoFocus: prop_types_1.default.bool,
};
SearchInput.defaultProps = {
    backButton: false,
    placeHolder: "Busca en Movistar",
    autoComplete: "off",
    needOpenModalResults: false,
    autoFocus: false,
};
//# sourceMappingURL=index.js.map